import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-picklist-input',
    templateUrl: './picklist-input.component.html',
    imports: [SharedModule]
})
export class PicklistInputComponent implements OnInit, OnChanges {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        options: string[];
    @Output()
        action = new EventEmitter();

    checkboxValue: string[] = [];

    isMultipleChoice: boolean = true;

    @Input()
        showNoneOfTheAbove: boolean;
    @Input()
        bqAnswer: string;
    noneOfTheAbove: boolean;

    noneOfTheAboveDisabled = false;

    showCustomNoneOfTheAbove = true;

    alchoholNoneOption = "I don't drink alcohol";
    tobaccoNoneOption = "I haven't used any nicotine products in the past 5 years.";

    alchoholQuestionName = "PT2_ALCOHOL_1";
    tobaccoQuestionName = "PT2_TOBACCO_1";

    constructor() {}

    ngOnInit(): void {
        // Check if multiple choice is allowed
        this.isMultipleChoice = !this.question.properties || 
            this.question.properties['MULTIPLE.CHOICE'] !== 'False';
            
        this.options.forEach(e => {
            this.checkboxValue[e] = false;
        });
        if (this.value != null && this.value.trim().length > 0) {
            this.value
                .split('COMMA')
                .filter(e => e != null)
                .forEach(e => {
                    this.checkboxValue[e] = true;
                });
        }
        
        if (this.bqAnswer && this.bqAnswer === 'false')
            this.noneOfTheAbove = true;   
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Check if multiple choice is allowed
        this.isMultipleChoice = !this.question.properties || 
            this.question.properties['MULTIPLE.CHOICE'] !== 'False';
        const baseNoneOfTheAboveSelected = this.bqAnswer?.toString() === 'false';
             
        this.options.forEach(e => {
            this.checkboxValue[e] = false;
        });
        if (this.value != null && this.value.trim().length > 0) {
            if (this.isMultipleChoice) {
                // Multiple selection mode - parse comma-separated values
                this.value
                    .split('COMMA')
                    .filter(e => e != null)
                    .forEach(e => {
                        this.checkboxValue[e] = true;
                    });
            } else {
                // Single selection mode - only one value
                this.checkboxValue[this.value] = true;
            }

            if ((this.checkboxValue[this.alchoholNoneOption] === true && this.name === this.alchoholQuestionName) || (this.checkboxValue[this.tobaccoNoneOption] === true && this.name === this.tobaccoQuestionName)) {
                this.noneOfTheAbove = true;
                this.showCustomNoneOfTheAbove = true;
            }else{
                this.noneOfTheAbove = false;
                this.showCustomNoneOfTheAbove = false;
            }

            this.noneOfTheAboveDisabled = Object.keys(this.checkboxValue)
                .filter(e => e != null)
                .filter(e => this.checkboxValue[e] === true && (e !== this.alchoholNoneOption && e !== this.tobaccoNoneOption)).length > 0;
        }else{
            this.noneOfTheAbove = baseNoneOfTheAboveSelected;
            this.showCustomNoneOfTheAbove = false;
            this.noneOfTheAboveDisabled = false;
        }
    }

    onClick(name: string) {
        if (this.value && this.value !== '') {
            this.valueChange.emit(null);
        }

        // For single selection mode, clear all other selections first
        if (!this.isMultipleChoice) {
            this.action.emit({
                name: Object.keys(this.checkboxValue).find(key => this.checkboxValue[key] === true) || '',
                value: false
            });
            Object.keys(this.checkboxValue).forEach(key => {
                this.checkboxValue[key] = false;
            });
            this.checkboxValue[name] = true;
            this.value = name;
               
            this.action.emit({
                name,
                value: this.checkboxValue[name]
            });
        } else {
            // Multiple selection mode - existing logic
            if ((this.checkboxValue[this.alchoholNoneOption] === true && this.name === this.alchoholQuestionName) || (this.checkboxValue[this.tobaccoNoneOption] === true && this.name === this.tobaccoQuestionName)) {
                this.noneOfTheAbove = true;
                this.showCustomNoneOfTheAbove = true;
            }else{
                this.noneOfTheAbove = false;
                this.showCustomNoneOfTheAbove = false;
            }

            this.value = Object.keys(this.checkboxValue)
                .filter(e => e != null)
                .filter(e => this.checkboxValue[e] === true)
                .join('COMMA');

                
            this.valueChange.emit(this.value);
            this.action.emit({
                name,
                value: this.checkboxValue[name]
            });
        }

        if (this.question.invalid) {
            this.question.invalid = false;
        }

    }

    onCustomNoneClick(name: string) {
        this.onClick(name);
    }

    onNoneClick(checked: boolean) {
        this.noneOfTheAbove = checked;
        this.action.emit({
            name: 'noneOfTheAbove',
            value: checked ? 'false' : 'true'
        });
    }
}
